import { API, graphqlOperation } from "aws-amplify";
import {
  createEventClientAccess,
  deleteEventClientAccess,
  updateEventClientAccess
} from "../graphql/mutations";
import { getEventClientAccess } from "./../graphql/queries";

export class ClientAccess {
  async createClientAccess(
    { id },
    { expiryDate, clientPassword, showPersonal, description }
  ) {
    const {
      data: { createEventClientAccess: result }
    } = await API.graphql(
      graphqlOperation(createEventClientAccess, {
        input: {
          expiryDate: expiryDate,
          clientPassword: clientPassword,
          showPersonal: showPersonal,
          description: description,
          eventClientAccessEventCompanyId: id
        }
      })
    );
    return result;
  }

  async updateClientAccess({
    id,
    clientPassword,
    showPersonal,
    description,
    expiryDate
  }) {
    const {
      data: { updateEventClientAccess: result }
    } = await API.graphql(
      graphqlOperation(updateEventClientAccess, {
        input: {
          id: id,
          clientPassword: clientPassword,
          showPersonal: showPersonal,
          description: description,
          expiryDate: expiryDate
        }
      })
    );
    return result;
  }

  async getClientAccessByCompany({ id }) {
    const getEventCompany = `query GetEventCompany($id: ID!) {
      getEventCompany(id: $id) {
        eventClientAccess {
          items {
            clientPassword
            expiryDate
            showPersonal
            description
            id
          }
        }
      }
    }`;
    try {
      const {
        data: {
          getEventCompany: {
            eventClientAccess: { items: result }
          }
        }
      } = await API.graphql(
        graphqlOperation(getEventCompany, {
          id: id
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async deleteClientAccess({ id }) {
    try {
      const {
        data: { deleteEventClientAccess: result }
      } = await API.graphql(
        graphqlOperation(deleteEventClientAccess, {
          input: {
            id: id
          }
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async getClientAccessById({ id }) {
    try {
      const {
        data: { getEventClientAccess: result }
      } = await API.graphql(
        graphqlOperation(getEventClientAccess, {
          id: id
        })
      );
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async getClientAccessByClientAccessId(eventId, nextToken) {
    const listEvents = /* GraphQL */ `
      query ListEvents(
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          items {
            id
          }
          nextToken
        }
      }
    `;

    try {
      const {
        data: { listEvents: events }
      } = await API.graphql({
        query: listEvents,
        variables: {
          filter: { clientAccess: { contains: eventId } },
          nextToken: nextToken
        },
        authMode: "API_KEY"
      });
      return events;
    } catch (err) {
      throw new Error(err.message);
    }
  }

  async authenticateClient(eventId, password) {
    if (!password) {
      return false;
    }
    const isClientPassword = /* GraphQL */ `
      query IsClientPassword($id: ID!, $clientPassword: String!) {
        isClientPassword(id: $id, clientPassword: $clientPassword) {
          id
          description
        }
      }
    `;

    try {
      const {
        data: { isClientPassword: isAuthenticated }
      } = await API.graphql({
        query: isClientPassword,
        variables: {
          id: eventId,
          clientPassword: password
        },
        authMode: "API_KEY"
      });
      if (isAuthenticated) {
        return true;
      }
    } catch (error) {
      return false;
    }
  }
}
